// BreadcrumbContext.tsx
import { createContext, useContext, useState, ReactNode } from "react";

interface BreadcrumbItem {
  label: any;
  path: string;
  browserBack?: boolean;
}

type BreadcrumbContextType = {
  breadCrumbItems: BreadcrumbItem[];
  setBreadcrumbItems: (items: any[]) => void;
};

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(
  undefined
);

export const BreadcrumbProvider = ({ children }: { children: ReactNode }) => {
  const [breadCrumbItems, setBreadcrumbItems] = useState([]);

  return (
    <BreadcrumbContext.Provider value={{ breadCrumbItems, setBreadcrumbItems }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumb = () => {
  const context = useContext(BreadcrumbContext);
  if (!context)
    throw new Error("useBreadcrumb must be used within a BreadcrumbProvider");
  return context;
};
